// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpInspirationImage_closeButton__thMMU","rounded":"PopUpInspirationImage_rounded__3RUbC","image":"PopUpInspirationImage_image__Fml1j"};